<template>
<v-flex class="white_background">
    <v-layout row wrap class="content-directory-page">
        <v-flex xs12 class="content-directory-page__title" data-qe-id="content-directory_title">
            {{contentDirectoryPageConstant.label.CONTENT_DIRECTORY_TITLE}}
        </v-flex>
        <content-directory></content-directory>
        <back-to-top :bottom="'20px'"></back-to-top>
    </v-layout>
</v-flex>
</template>
<script>
    import { contentDirectoryPageConstant } from "./contentDirectoryPage.constant";
    import BackToTop from '../Layout/BackToTop.vue';
    import ContentDirectory from "./ContentDirectory";

    export default {
        name: 'ContentDirectoryPage',
        components: {
            ContentDirectory,
            BackToTop,
        },
        data() {
            return {
                contentDirectoryPageConstant,
            };
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .content-directory-page {
        position: relative;
        margin-top: 64px;
        background-color: $white;
        padding: 0 80px;

        @include breakpoint(md) {
            padding: 0 45px;
        }

        @include breakpoint(xs) {
            padding: 0 5px;
        }


        &__title {
            background-color: $white;
            color: $ypo-blue;
            font-family: 'Raleway', sans-serif;
            font-size: 30px;
            font-weight: 500;
            padding: 20px 10px 0 0;
        }
        &__subtitle {
        font-weight: 500;
        font-size: 14px !important;
        color: $black;
        letter-spacing: 0.29px;
        line-height: 24px;
        padding: 0 15px 5px 0;
        margin-bottom: 10px;
        }
    }
 @media (max-width: 767px){
     .content-directory-page{
         margin-top: 55px;
         &__title{
             font-size: 18px;
             padding: 10px 15px 0 15px;
         }
         &__subtitle{
             padding: 0 15px 5px 15px;
         }
     }
    }
</style>
